import React from 'react';

import { CustomMenu } from './custom-menu';
import { MeControlBase } from './me-control-base';

export class MeControl extends React.PureComponent {
  render() {
    return (
      <MeControlBase
        {...this.props}
        CustomMenu={CustomMenu}
      />
    );
  }
}
